import { Injectable } from '@angular/core';
import { Position, PositionCreationMode } from '@core/models';
import { DashboardHookService } from '@core/services/hooks/dashboard-hook/dashboard-hook.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardHookCustomService extends DashboardHookService {
  constructor() {
    super();
  }

  findOpenPosition(positions: Position[]): Position {
    return (
      this.findRichiestaFidoOpen(positions) ||
      this.findUtilizzoFidoOpen(positions) ||
      this.findRichiestaFidoCompleted(positions)
    );
  }

  findCreationMode(positions: Position[]): PositionCreationMode {
    if (
      !!this.findRichiestaFidoCompleted(positions) &&
      !this.findUtilizzoFidoOpen(positions)
    ) {
      return PositionCreationMode.utilizzoFido;
    } else if (
      !this.findRichiestaFidoOpen(positions) &&
      !this.findRichiestaFidoCompleted(positions)
    ) {
      return PositionCreationMode.richiestaFido;
    } else {
      return null;
    }
  }

  isActionRevoked(positions: Position[]): boolean {
    return !!positions.find(
      x =>
        x.hasPhase('300') &&
        (x.hasStatus('REV-FIDO') || x.hasStatus('REVOCA-FIDO'))
    );
  }

  /**
   * restituisce la prima position di richiesta fido che risulta aperta e non completata
   */
  private findRichiestaFidoOpen(positions: Position[]): Position {
    return positions.find(
      x =>
        x.isCqsRf() &&
        x.isOpen() &&
        !x.hasStatus('FIDO-OK') &&
        !x.hasPhase('300')
    );
  }

  /**
   * restituisce la prima position di richiesta fido che risulta completata
   */
  private findRichiestaFidoCompleted(positions: Position[]): Position {
    return positions.find(
      x => x.isCqsRf() && x.hasStatus('FIDO-OK') && x.hasPhase('300')
    );
  }

  /**
   * restituisce la prima position di utilizzo fido che risulta aperta e non completata
   */
  private findUtilizzoFidoOpen(positions: Position[]): Position {
    return positions.find(
      x =>
        x.isCqsUf() &&
        x.isOpen() &&
        !x.hasStatus('LIQ-POS') &&
        !x.hasPhase('400')
    );
  }
}
